import { useTranslation } from 'react-i18next';

import * as styles from './styles';

type CardNoResultsProps = {
  title?: string;
  subtitle?: string;
};

export function CardNoResults({ title, subtitle }: CardNoResultsProps) {
  const { t } = useTranslation('common');

  return (
    <div className={styles.container()}>
      <p className={styles.title()}>{title || t('thereAreNoRecordsTitle')}</p>
      <p className={styles.subtitle()}>
        {subtitle || t('thereAreNoRecordsSubTitle')}
      </p>
    </div>
  );
}
